
import { ProfessionData } from '../types/professionTypes';

export const aeronautique: ProfessionData = {
  title: "Aéronautique",
  slug: "aeronautique", 
  description: "Solutions de gestion des déchets spécialisées pour l'industrie aéronautique",
  icon: "Plane",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Métaux spéciaux",
      description: "Alliages d'aluminium, titane, aciers spéciaux utilisés dans la construction aéronautique",
      solutions: ["Tri spécialisé", "Valorisation métaux précieux", "Recyclage certifié"],
      environmentalBenefit: "Préservation des ressources rares et réduction de l'empreinte carbone"
    },
    {
      type: "Composites",
      description: "Matériaux composites carbone, fibres de verre et résines",
      solutions: ["Collecte sélective", "Traitement spécialisé", "Valorisation énergétique"],
      environmentalBenefit: "Évite l'enfouissement de matériaux techniques"
    },
    {
      type: "Déchets électroniques",
      description: "Équipements avioniques, systèmes électroniques embarqués",
      solutions: ["Collecte DEEE", "Démantèlement certifié", "Récupération métaux précieux"],
      environmentalBenefit: "Protection contre la pollution électronique"
    }
  ],
  relatedProfessions: ["electricien", "metallurgie", "electronique"]
};
